/**************************************************
 * Nombre:       Apartado_Personas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Tarjeta_Personas from "../Tarjeta/Tarjeta_Personas";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import uno from '../../Recursos/Temporales/uno.png'
import dos from '../../Recursos/Temporales/dos.png'
import tres from '../../Recursos/Temporales/tres.png'

const Apartado_Personas = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center', mt: 0}}>
                <Typography sx={{fontWeight: 600, textAlign: 'center', lineHeight: 1.1, fontSize: sCell ? 16 : 18}}>
                    Personas que ya han visto resultados
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'center', mt: 1}}>
                <Typography sx={{fontWeight: 800, textAlign: 'center', lineHeight: 1.1, fontSize: 24}}>
                    Deja tu huella
                </Typography>
            </Grid>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={4}
                sx={{mt: 8}}
            >

                {items.map((it, index) => (
                    <Grid container size={{xs: 6, sm: 4, md: 3}} sx={{justifyContent: 'flex-start'}}>
                        <Tarjeta_Personas item={it}/>
                    </Grid>
                ))}

            </Grid>

        </Grid>
    )

}
export default Apartado_Personas

const items = [
    {
        nombre:'Camila Zambrano',
        profesion: 'Ing Agroindustrial',
        img: uno
    },
    {
        nombre:'Romario Huertas',
        profesion: 'Estudiante Universitario',
        img: dos
    },
    {
        nombre:'Alejandor Bautizta',
        profesion: 'Gerente Comercial',
        img: tres
    },
]